import { Form } from 'antd';
import styled, { css } from 'styled-components';

interface CustomFormItemProps {
	$required: boolean;
}

const labelRequired = css`
	.ant-form-vertical .ant-form-item-label > label::after,
	.ant-form-item-label > label::after {
		content: '*';
		margin-left: 5px;
		color: ${({ theme }) => theme.colors.danger};
		font-size: 16px !important;
		font-weight: 600 !important;
		display: inline-block !important;
	}
`;

const labelDefault = css`
	.ant-form-vertical .ant-form-item-label > label::after,
	.ant-form-item-label > label::after {
		display: none !important;
	}
`;

export const CustomFormItem = styled(Form.Item)<CustomFormItemProps>`
	.ant-form-item-label > label {
		font-size: 16px !important;
		font-weight: 600 !important;
		margin-bottom: 0 !important;
		line-height: 24px !important;
		color: ${({ theme }) => theme.colors.text} !important;
	}

	.ant-form-item-label > label::before {
		display: none !important;
	}

	.ant-skeleton {
		width: 100% !important;
	}

	.ant-skeleton-button {
		width: 100% !important;
		height: 40px !important;
		border-radius: 4px !important;
	}

	${({ $required }) => ($required ? labelRequired : labelDefault)}
`;
